export default __webpack_public_path__ + "static/media/coach@2x.476800be.webp";